<script>
	import { Col, Row } from "sveltestrap";
	import VehicleMakeTable from "./VehicleModelTable.svelte";
	import { onMount, onDestroy } from "svelte";
	import {
		loading,
		totalPages,
		loadingStatus,
		initPage,
	} from "../../../../store/store";
	import EditForm from "./EditForm.svelte";
	import { resetFields } from "src/validators/VehicleMake";
	import {
		deleteVehicleModel,
		getVehicleModels,
		changeVehicleModelStatus,
	} from "src/services/vehicle";

	let data = [];
	let idStatus;

	async function setVehicleModels() {
		try {
			loading.set(true);
			const res = await getVehicleModels($initPage);
			data = res?.data?.dataList;
			totalPages.set(res?.data?.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);
		}
	}

	const refreshData = async (type) => {
		const isDelete = type === "delete";
		try {
			isDelete ? loading.set(true) : loadingStatus.set(true);
			await setVehicleModels();
		} catch (err) {
			console.log(err);
		} finally {
			isDelete ? loading.set(false) : loadingStatus.set(false);
		}
	};

	async function handleStatusChange(id, status) {
		idStatus = id;
		try {
			loadingStatus.set(true);
			const res = await changeVehicleModelStatus(id, status);
			if (res?.status === 200) {
				refreshData();
			}
		} catch (err) {
			console.log(err);
			loadingStatus.set(false);
		}
	}

	async function handleDelete(id) {
		idStatus = id;
		try {
			loading.set(true);
			const res = await deleteVehicleModel(id);
			if (res?.status === 200) {
				refreshData("delete");
			}
			loading.set(false);
		} catch (err) {
			console.log(err);
			loading.set(false);
		}
	}

	onMount(async () => {
		resetFields();
		await setVehicleModels();
	});

	onDestroy(() => {
		initPage.set(1);
		resetFields();
	});
</script>

<Row>
	<EditForm isEdit={false} />
	<Col class="d-flex justify-content-end" xs={6}>
		<div class="mx-4 text-center">
			<Row>
				<input
					id="fileInput"
					type="file"
					multiple={false}
					hidden="hidden"
					on:change={(e) =>
						handleCsvImport(
							e,
							"/v1/models/csvFileImport",
							"CarModels"
						)}
				/>
				<label
					type="button"
					for="fileInput"
					id="customButton"
					class="btn themeButton primary px-4 btn"
					block>Import CSV</label
				>
			</Row>
			<Row>
				<p>
					<a
						href="/assets/csv/vehicle_model_Template.csv"
						target="_blank"
						download="vehicle_model_template.csv"
						rel="noreferrer"
						class="link link-text"
					>
						Download CSV Template
					</a>
				</p>
			</Row>
		</div>
	</Col>
	<Col class="my-5">
		<VehicleMakeTable
			{data}
			{handleStatusChange}
			{idStatus}
			{handleDelete}
		/>
	</Col>
</Row>
